import { render, staticRenderFns } from "./ImageAnnouncements.vue?vue&type=template&id=d2f38b76"
import script from "./ImageAnnouncements.vue?vue&type=script&lang=js"
export * from "./ImageAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports